// Convert a string to an ArrayBuffer
export const stringToArrayBuffer = (str) => {
  const encoder = new TextEncoder();
  return encoder.encode(str);
};

// Convert ArrayBuffer to string
export const arrayBufferToString = (buffer) => {
  const decoder = new TextDecoder();
  return decoder.decode(buffer);
};

// Generate a random IV (Initialization Vector)
export const generateRandomIV = () => {
  return crypto.getRandomValues(new Uint8Array(12)); // AES-GCM uses 12-byte IV
};

export const encryptData = async (data, password) => {
  const iv = generateRandomIV();
  const encoder = new TextEncoder();
  const encodedData = encoder.encode(data);

  // Hash the password to ensure the key length is 256 bits (32 bytes)
  const hashedPassword = await crypto.subtle.digest("SHA-256", encoder.encode(password));

  // Import the hashed password as a key for AES-GCM
  const key = await crypto.subtle.importKey(
    "raw",
    hashedPassword,
    { name: "AES-GCM" },
    false,
    ["encrypt"]
  );

  // Encrypt data
  const encryptedData = await crypto.subtle.encrypt(
    { name: "AES-GCM", iv: iv },
    key,
    encodedData
  );

  // Extract the authTag from the encrypted data
  const authTag = encryptedData.slice(encryptedData.byteLength - 16);
  const encryptedContent = encryptedData.slice(0, encryptedData.byteLength - 16);

  return {
    encryptedData: new Uint8Array(encryptedContent),
    aiv: iv,
    authTag: new Uint8Array(authTag),
  };
};

export const decryptData = async (encryptedData, password, iv, authTag) => {
  const decoder = new TextDecoder();
  const encoder = new TextEncoder();

  // Hash the password to ensure the key length is 256 bits (32 bytes)
  const hashedPassword = await crypto.subtle.digest("SHA-256", encoder.encode(password));

  // Import the hashed password as a key for AES-GCM
  const key = await crypto.subtle.importKey(
    "raw",
    hashedPassword,
    { name: "AES-GCM" },
    false,
    ["decrypt"]
  );

  // Combine the encrypted data and authTag
  const combinedData = new Uint8Array(encryptedData.length + authTag.length);
  combinedData.set(encryptedData);
  combinedData.set(authTag, encryptedData.length);

  // Decrypt the data
  const decryptedData = await crypto.subtle.decrypt(
    { name: "AES-GCM", iv: iv },
    key,
    combinedData
  );

  return decoder.decode(decryptedData);
};
